import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import mkcRatings from "../../../../src/data/articles/cube-prospective-murders-at-karlov-manor-commander/mkc-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  mkcRatings,
  ProspectiveIntro,
  React
};